import estilos from "./Experiencia.module.css";
import { experiencias } from "../../data/experiencias";

const Experiencia = () => {
  return (
    <section id="experiencia" className={estilos.secao}>
      <span className={estilos.etiqueta}>// Experiência</span>
      <h2 className={estilos.titulo}>Experiência Prática</h2>

      <div className={estilos.lista}>
        {experiencias.map((exp) => (
          <div key={exp.titulo} className={estilos.item}>
            <div className={estilos.ponto} />
            <h3 className={estilos.itemTitulo}>{exp.titulo}</h3>
            <p className={estilos.itemDescricao}>{exp.descricao}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experiencia;
